import { Box } from '@mui/material';
import searchEmptyIcon from 'assets/images/search-icon.png';

export const NoRowsOverlay = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        py: 2,
      }}
    >
      <Box
        component="img"
        src={searchEmptyIcon}
        alt=""
        sx={{
          display: 'block',
          width: '53px',
          height: '79px',
        }}
      />
    </Box>
  );
};
